export default "/images/hy-room-tour-600.png?a0c7a5ee632fcea87b8d681836027760";